export default __webpack_public_path__ + "media/images/temporary/christmas-1-1810efcdfb0e474f8841d0970d5efc11.jpg";